// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-speed-dial[data-v-7c2278fe]{position:absolute}.v-btn--floating[data-v-7c2278fe]{position:relative}.fondo-app[data-v-7c2278fe]{background-color:#f6f8f9!important}.toolbar-no-menu[data-v-7c2278fe]{background:#f5f5f5!important;box-shadow:0 4px 15px 0 rgba(0,0,0,.09)!important;color:#727891!important;z-index:1;right:0;left:0;position:fixed}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
